import { PiqEnvironment } from 'softcat:config/piq-environment.ts';

const LocalhostEnvironmentProxy = import.meta.env.VITE_ENVIRONMENT_PROXY as PiqEnvironment;

export const EnvironmentConfig = {
    LocalhostEnvironmentProxy,
};
